<!-- 为ASA投放方式展示不展示返点比例 -->
<template>
  <div class="home " :class="{ 'v2container': source == 'v2' }">
    <FilterLayout v-model="searchForm" @onSubmit="onSubmit" :flexFlag="true">
      <el-col :md="12" :sm="12" :lg="8">
        <el-form-item label="渠道名/域名">
          <el-input v-model.trim="searchForm.search" placeholder="搜索渠道名称/域名"></el-input>
        </el-form-item>
      </el-col>
      <el-col :md="12" :sm="12" :lg="8">
        <el-form-item label="渠道">
          <SelectChannel v-model="searchForm.channel"></SelectChannel>
        </el-form-item>
      </el-col>
      <el-col :md="12" :sm="12" :lg="8">
        <el-form-item label="渠道负责人">
          <el-select v-model="searchForm.admin_id" filterable placeholder="全选" :clearable="true" :multiple="true">
            <el-option v-for="item in SadminUserList" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="12" :sm="12" :lg="8">
        <el-form-item label="投放方式">
          <el-select v-model="searchForm.system_create" placeholder="默认全部" filterable>
            <el-option v-for="item in FilterOps" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </FilterLayout>
    <TableLayout :column="column" :data="tableData.data" :total="tableData.total" :loading="tableData.loading"
      :currentPage="tableOpt.currentPage" :params="searchForm" @pageChange="onPageChange" @sizeChange="onSizeChange"
      @sortChange="onSortChange">
      <template #table-option>
        <el-button type="primary" @click="onShowAdd">新增投放统计</el-button>
        <!-- <el-button
          type="text"
          size="small"
          @click=""
          >获取二维码</el-button
        > -->
      </template>

      <template #day="scope">
        <div>今天</div>
        <div>累计</div>
      </template>

      <template #info="scope">
        <el-tooltip class="item" effect="dark" placement="top-start">
          <div slot="content">
            <div>
              <span class="fontW16"> 关键行为名称：</span><span>{{ scope.row.event_name }}</span>
            </div>
            <br />
            <div>
              <span class="fontW16"> 关键行为ID：</span><span>{{ scope.row.event_id }}</span>
            </div>
            <br />
            <div>
              <span class="fontW16">总预算：</span><span>{{
                scope.row.all_budget
                  ? Number(scope.row.all_budget).toFixed(2) + "元"
                  : ""
              }}</span>
            </div>
            <br />
            <div>
              <span class="fontW16">买量单价：</span><span>{{
                scope.row.purchase_price
                  ? Number(scope.row.purchase_price).toFixed(2) + "元"
                  : ""
              }}</span>
            </div>
            <br />
            <div>
              <span class="fontW16">发布时间：</span><span>{{
                scope.row.release_date != "0" && scope.row.release_date
                  ? moment(scope.row.release_date).format("YYYY-MM-DD")
                  : ""
              }}</span>
            </div>
            <br />
            <div>
              <span class="fontW16">结算时间：</span><span>{{
                scope.row.settlement_date != "0" && scope.row.settlement_date
                  ? moment(scope.row.settlement_date).format("YYYY-MM-DD")
                  : ""
              }}</span>
            </div>
            <br />
            <div>
              <span class="fontW16">备注：</span>
              <span>{{ scope.row.note }}</span>
            </div>
          </div>
          <el-button type="text">显示详情</el-button>
        </el-tooltip>
      </template>

      <template #system_create="scope">{{
        formatPlatform(scope.row.system_create)
      }}</template>

      <template #device_new_all="scope">
        <div>{{ scope.row.device_new | formatUnit }}</div>
        <div>{{ scope.row.device_new_all | formatUnit }}</div>
      </template>

      <template #statistics="scope">
        <div>总收入：{{ scope.row.all_income_recycling | formatnum }}</div>
        <div>订单：{{ scope.row.order_income_recycling | formatnum }}</div>
        <div>广告：{{ scope.row.ad_income_recycling | formatnum }}</div>
      </template>

      <template #option="scope">
        <el-button type="text" size="small" @click="getCode(scope.row)" v-if="scope.row.system_create == 55 ||
          scope.row.system_create == 18 ||
          scope.row.system_create == 3
        ">获取代码</el-button>
        <template v-else>
          <!-- <el-button @click="onLinkMore(scope.row)" type="text" size="small">查看</el-button> -->
          <el-button type="text" size="small" @click="getURL(scope.row)"
            v-if="(overseasUrlArr.indexOf(scope.row.system_create) !== -1 && scope.row.tracker_token) || urlArr.indexOf(scope.row.system_create) === -1">获取URL</el-button>
          <el-button v-if="scaleArr.indexOf(scope.row.system_create) !== -1" type="text" size="small"
            @click="openRebate(scope.row)">返点比例</el-button>
          <el-button v-if="overseasArr.indexOf(Number(scope.row.system_create)) != -1" type="text" size="small"
            @click="openServiceRebateRatio(scope.row)">服务比例</el-button>
          <el-button v-if="moneyArr.indexOf(scope.row.system_create) !== -1" type="text" size="small"
            @click="openConsume(scope.row)">消耗金额</el-button>
          <el-button v-if="scope.row.system_create == 8 || scope.row.system_create == 9" type="text" size="small"
            @click="changeData(scope.row)">修改</el-button>
          <el-button
            v-else-if="scope.row.system_create == '35' || overseasArr.indexOf(Number(scope.row.system_create)) != -1"
            type="text" size="small" @click="changeDataOne(scope.row)">修改</el-button>
          <span v-else-if="urlArr.indexOf(scope.row.system_create) !== -1"></span>
          <el-button v-else type="text" size="small" @click="changeDataOne(scope.row)">修改</el-button>
        </template>
        <el-button v-if="scope.row.system_create == 55 || scope.row.system_create == 18" type="text" size="small"
          @click="changeDataOne(scope.row)">修改
        </el-button>
      </template>
    </TableLayout>

    <!-- 新增投放统计弹窗 -->
    <el-dialog title="新增" :visible.sync="showAdd" :close-on-click-modal="false" width="600px">
      <el-form :model="addForm" label-width="130px" ref="addForm" :rules="addFormRules" size="small">
        <el-form-item label="投放方式" required>
          <el-select v-model="addForm.system_create" placeholder="请选择" filterable style="width: 240px"
            @change="otherPlatformListchange">
            <el-option v-for="item in otherPlatformListHandle" :key="item.value" :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 投放版本，只有选择巨量引擎的时候才生效，必填 -->
        <el-form-item label="投放版本" required v-if="versionFlag">
          <el-select v-model="addForm.version" placeholder="请选择" style="width: 240px">
            <el-option label="v1.0" value="1">
            </el-option>
            <el-option label="v2.0" value="2">
            </el-option>
          </el-select>
          <!-- 提示 -->
          <el-popover placement="top-start" width="200" trigger="hover">
            <p>
              此处为投放平台版本选择，如果投老版选择v1.0，投新版选择v2.0
            </p>
            <i class="el-icon-info" slot="reference"></i>
          </el-popover>
        </el-form-item>

        <template v-if="addForm.system_create !== ''">
          <el-form-item label="渠道名称" prop="title">
            <el-input v-model.trim="addForm.title" style="width: 240px" :placeholder="addForm.system_create == 55 || addForm.system_create == 18
              ? '用于标识落地页'
              : '用于标识第三方投放平台'
              "></el-input>
          </el-form-item>

          <el-form-item label="渠道号" prop="origin">
            <el-input v-model.trim="addForm.origin" style="width: 240px" :placeholder="addForm.system_create == 55 || addForm.system_create == 18
              ? '与落地页apk渠道号一致'
              : '与在该广告平台投放的包名一致'
              " @blur="onBlur" @input="originInputChange"></el-input>
          </el-form-item>

          <el-form-item
            :label="addForm.system_create == '26' ? '账户ID' : overseasArr.indexOf(addForm.system_create) != -1 ? '子账户ID' : planIdArr.indexOf(addForm.system_create) !== -1 ? '计划ID' : '任务ID'"
            prop='account_id'
            v-if="addForm.system_create == '13' || addForm.system_create == '24' || addForm.system_create == '25' || addForm.system_create == '26' || overseasArr.indexOf(addForm.system_create) != -1 || planIdArr.indexOf(addForm.system_create) !== -1 || addForm.system_create == '58'">
            <el-input style="width: 240px" show-word-limit v-model="addForm.account_id" :placeholder="addForm.system_create == '26' ? '账户ID' : overseasArr.indexOf(addForm.system_create) != -1 ? '子账户ID' :
              planIdArr.indexOf(addForm.system_create) !== -1 ? '计划ID' : '任务ID'">
            </el-input>
          </el-form-item>

          <el-form-item label="变现目标" prop="invest_target">
            <el-select v-model="addForm.invest_target" placeholder="请选择">
              <el-option label="付费" value="1"></el-option>
              <el-option label="广告" value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="浅层转化目标" prop="conversion_target"
            v-if="conversion_target_flag.indexOf(addForm.system_create) !== -1">
            <el-select v-model="addForm.conversion_target" placeholder="请选择">
              <el-option v-for="item in conversion_target_list" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="addForm.system_create === 81 ? '授权token' : 'adjust链接识别码'"
            :placeholder="addForm.system_create === 81 ? '请输入授权tokken' : ''" prop="tracker_token"
            :required="addForm.system_create === 81" v-if="trackerTokenArr.indexOf(addForm.system_create) !== -1">
            <el-input style="width: 240px" v-model="addForm.tracker_token" placeholder="请选择">

            </el-input>
          </el-form-item>

          <el-form-item label="返点比例" v-show="ratio_show"
            :prop="rebateFlag.indexOf(addForm.system_create) !== -1 ? 'ratio' : ''">
            <el-input v-model="addForm.ratio" style="width: 240px" placeholder='请输入返点比例' @blur="ratioBlur">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>

          <el-form-item label="返点比例生效日期" v-show="ratio_show">
            <el-date-picker v-model="addForm.date" type="date" style="width: 240px" placeholder="选择日期"
              value-format="yyyy-MM-dd" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="服务比例" v-show="overseasArr.indexOf(addForm.system_create) != -1">
            <el-input v-model.trim="addForm.service_ratio" style="width: 240px" placeholder="请输入服务比例" @blur="ratioBlur">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>

          <el-form-item label='服务比例生效日期' v-show="overseasArr.indexOf(addForm.system_create) != -1">
            <el-date-picker v-model="addForm.service_date" :picker-options="pickerOptions" type="date"
              style="width: 240px" placeholder="选择日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="发布时间" v-if="allMoneyArr.indexOf(addForm.system_create) !== -1" prop="release_date">
            <el-date-picker v-model="addForm.release_date" type="date" style="width: 240px" placeholder="选择日期"
              value-format="yyyy-MM-dd" :picker-options="releasePickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="总预算" v-if="allMoneyArr.indexOf(addForm.system_create) !== -1" prop="all_budget">
            <el-input style="width: 240px" @keyup.native="
              changepromotino_money(addForm.all_budget, 'all_budget')
              " v-model="addForm.all_budget" controls-position="right" placeholder="单位（元）"></el-input>
          </el-form-item>

          <el-form-item label="买量单价" v-if="allMoneyArr.indexOf(addForm.system_create) !== -1" prop="purchase_price">
            <el-input style="width: 240px" v-model="addForm.purchase_price" controls-position="right" @keyup.native="
              changepromotino_money(addForm.purchase_price, 'purchase_price')
              " placeholder="单位（元）"></el-input>
          </el-form-item>

          <el-form-item label="是否监测链接双端共用" label-width="200px" v-if="xt_ios_android_lisiten_show">
            <el-radio-group v-model="is_lisiten">
              <el-radio label="1">是</el-radio>
              <el-radio label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="监测链接共用应用" label-width="200px" v-if="is_lisiten == 1 && xt_ios_android_lisiten_show">
            <el-select v-model="addForm.lisiten_appid" placeholder="请选择" style="width: 240px"
              @change="lisitenAppidChange">
              <el-option v-for="item in lisitenApp" :key="item.id" :label="item.title" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="渠道类型" prop="channel_type"
            v-if="showChannelTypeArr.indexOf(addForm.system_create) === -1">
            <el-select v-model="addForm.channel_type" filterable placeholder="请选择">
              <el-option v-for="(v, i) in platformChannelType" :key="i" :label="v.label" :value="v.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="渠道负责人" prop="admin_id">
            <el-select v-model="addForm.admin_id" filterable placeholder="请选择">
              <el-option v-for="item in adminUserList" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" :prop="rebateFlag.indexOf(addForm.system_create) !== -1 ? 'note' : ''">
            <el-input type="textarea" style="width: 240px" :rows="3" maxlength="32" show-word-limit
              v-model="addForm.note" @input="testareaChange($event)"></el-input>
          </el-form-item>
          <!-- 新增时event_type字段不用传给后端 -->
          <!-- 关键行为类型 新增时的显示标杆控制cl_jl_flag 修改的显示标杆控制edit_jl_cl_flag -->
          <el-form-item label="行为类型" v-if="cl_jl_flag">
            <el-radio v-model="addForm.event_type" label="1"
              @click.native.stop.prevent="getCurrentRow('1')">付费</el-radio>
            <el-radio v-model="addForm.event_type" label="2"
              @click.native.stop.prevent="getCurrentRow('2')">广告</el-radio>
            <el-radio v-model="addForm.event_type" label="4"
              @click.native.stop.prevent="getCurrentRow('4')">混合行为</el-radio>
          </el-form-item>
          <el-form-item label="行为ID" v-if="cl_jl_flag && addForm.event_type"
            :prop="addForm.event_type ? 'event_id' : 'event_idNo'">
            <el-input v-if="addForm.event_type == '2' || addForm.event_type == '4'" v-model="addForm.event_id"
              style="width: 240px" @blur="eventBlur"></el-input>
            <el-select v-model="addForm.event_id" placeholder="请选择" clearable v-if="addForm.event_type == '1'"
              @change="changeEventName">
              <el-option v-for="item in eventIdList" :key="item.action_id"
                :label="item.action_id + '—' + item.action_name" :value="item.action_id">
              </el-option>
            </el-select>
            <!-- 提示 -->
            <el-popover style="margin-left: 20px;" placement="top-start" width="260" trigger="hover"
              v-if="addForm.event_type == '4'">
              <div>
                <h4>混合回传行为ID填写规范如下：</h4>
                <p>
                  1、各行为之间采用“<span style="color:red">#</span>”号分隔 <br>
                  ex：（项目组行为#广告行为#中台行为）
                </p>
                <P>
                  2.项目的行为ID命名统一用“<span style="color:red">xm_</span>”开头 <br>
                  ex：（xm_行为ID）
                </P>
                <p>
                  3.中台标准行为ID如下（自己手动复制）<br>
                <div class="fl_right">
                  <span>active</span> <span>激活</span>
                </div>
                <div class="fl_right">
                  <span>register</span> <span>注册用户</span>
                </div>
                <div class="fl_right">
                  <span>create_general</span> <span>下单(普通订单)</span>
                </div>
                <div class="fl_right">
                  <span>create_subscribe</span> <span>下单(订阅订单)</span>
                </div>
                <div class="fl_right">
                  <span>create_all</span> <span>下单(全部订单)</span>
                </div>
                <div class="fl_right">
                  <span>pay_general</span> <span>支付(普通订单)</span>
                </div>
                <div class="fl_right">
                  <span>pay_subscribe</span> <span>支付(订阅订单)</span>
                </div>
                <div class="fl_right">
                  <span>pay_all</span> <span>支付(全部订单)</span>
                </div>
                <div class="fl_right">
                  <span>pay_renew</span> <span>续订</span>
                </div>
                <div class="fl_right">
                  <span>keep</span> <span>次留</span>
                </div>
                </p>
              </div>
              <i class="el-icon-info" slot="reference"></i>
            </el-popover>
          </el-form-item>
          <el-form-item label="行为名称" :prop="addForm.event_type ? 'event_name' : 'event_nameNo'"
            v-if="cl_jl_flag && addForm.event_type">
            <el-input v-model.trim="addForm.event_name" style="width: 240px"></el-input>
          </el-form-item>
        </template>
      </el-form>
      <div v-if="addSpecialShow && urlArr.indexOf(addForm.system_create) !== -1" style="margin-left: 45px">
        <p>*添加后需要获取代码去第三方配置监测链接</p>
        <p>*该渠道下所有所有归因来的投放计划会自动记录</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAdd = false">取 消</el-button>

        <template>
          <el-button type="primary" @click="onNextSpecial" v-if="specialStep">下一步</el-button>
          <el-button type="primary" @click="onAdd" :disabled="addBtn" v-else>确 定</el-button>
        </template>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="showchangeData" title="修改信息" :close-on-click-modal="false">
      <div v-loading="fullscreenLoading"></div>
      <el-form :model="changeForm" label-width="140px" ref="changeForm" v-if="!fullscreenLoading" :rules="changeRules">
        <el-form-item label="收款账户" prop="proceeds_user">
          <el-input v-model.trim="changeForm.proceeds_user" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item :label="changeSystemCreate == 8 ? '订单ID' : '任务ID'" prop="ad_id">
          <el-input v-model.trim="changeForm.ad_id" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item :label="changeSystemCreate == 8 ? '订单名称' : '任务名称'" prop="ad_name">
          <el-input v-model.trim="changeForm.ad_name" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="渠道负责人" prop="admin_id" :rules="changeForm.admin_date
          ? [{ required: true, message: '请填写渠道负责人' }]
          : changeRules.admin_id
          ">
          <el-select v-model="changeForm.admin_id" filterable placeholder="请选择">
            <el-option v-for="item in adminUserList" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="负责人生效时间" prop="admin_date" :rules="changeForm.admin_id
          ? [{ required: true, message: '请填写负责人生效时间' }]
          : changeRules.admin_date
          ">
          <el-date-picker v-model="changeForm.admin_date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            :picker-options="releasePickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="渠道类型" prop="channel_type" v-if="showChannelTypeArr.indexOf(addForm.system_create) === -1">
          <el-select v-model="changeForm.channel_type" filterable placeholder="请选择">
            <el-option v-for="(v, i) in platformChannelTypeEdie" :key="i" :label="v.label" :value="v.value"
              :disabled="v.disa" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input type="textarea" style="width: 240px" :rows="3" maxlength="32" show-word-limit
            v-model="changeForm.note" @input="testareaChange($event)"></el-input>
        </el-form-item>
        <el-form-item label="渠道备注生效时间" prop="note_date" :rules="changeForm.note
          ? [{ required: true, message: '请填写渠道备注生效时间' }]
          : changeRules.note_date
          " v-show="changeForm.note">
          <el-date-picker v-model="changeForm.note_date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            :picker-options="pickerOptionsNote">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showchangeData = false">取 消</el-button>

        <el-button type="primary" @click="onChangeData">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="showchangeDataOne" title="修改信息" :close-on-click-modal="false" @close="dataOneDown">
      <div v-loading="fullscreenLoadingOne"></div>
      <el-form :model="changeFormOne" label-width="140px" ref="changeFormOne" v-if="!fullscreenLoadingOne"
        :rules="changeFormOneRules">
        <el-form-item label="渠道负责人" prop="admin_id" :rules="changeFormOne.admin_date
          ? [{ required: true, message: '请填写渠道负责人' }]
          : changeRules.admin_id
          ">
          <el-select v-model="changeFormOne.admin_id" filterable placeholder="请选择">
            <el-option v-for="item in adminUserList" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="akey" v-if="akeyFlag">
          <el-input v-model.trim="changeFormOne.akey" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="token" v-if="tokenlag">
          <el-input v-model.trim="changeFormOne.access_token" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="负责人生效时间" prop="admin_date" :rules="changeFormOne.admin_id
          ? [{ required: true, message: '请填写负责人生效时间' }]
          : changeRules.admin_date
          ">
          <el-date-picker v-model="changeFormOne.admin_date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结算时间" prop="settlement_date"
          v-if="allMoneyArr.indexOf(Number(changeFormOne.platform)) !== -1">
          <el-date-picker v-model="changeFormOne.settlement_date" type="date" value-format="yyyy-MM-dd"
            :picker-options="releasePickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="渠道类型" prop="channel_type" v-if="showChannelTypeArr.indexOf(addForm.system_create) === -1">
          <el-select v-model="changeFormOne.channel_type" filterable placeholder="请选择">
            <el-option v-for="(v, i) in platformChannelTypeEdie" :key="i" :label="v.label" :value="v.value"
              :disabled="v.disa" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注" :prop="rebateFlag.indexOf(Number(changeFormOne.platform)) !== -1 ? 'note' : ''">
          <el-input type="textarea" style="width: 240px" :rows="3" maxlength="32" show-word-limit
            v-model="changeFormOne.note" @input="testareaChange($event)"></el-input>
        </el-form-item>
        <el-form-item label="渠道备注生效时间" prop="note_date" :rules="changeFormOne.note
          ? [{ required: true, message: '请填写渠道备注生效时间' }]
          : changeRules.note_date
          " v-show="changeFormOne.note">
          <el-date-picker v-model="changeFormOne.note_date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            :picker-options="pickerOptionsNote">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="关键行为名称" :prop="changeFormOne.event_id ? 'event_name' : 'event_nameNo'"
          v-if="edit_jl_cl_flag">
          <el-input v-model.trim="changeFormOne.event_name" style="width: 240px"></el-input>
        </el-form-item>
        <!-- <el-form-item label="关键行为ID" v-if="edit_jl_cl_flag">
          <el-input v-model.trim="changeFormOne.event_id" style="width: 240px"></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showchangeDataOne = false">取 消</el-button>

        <el-button type="primary" @click="onChangeDataOne">确 定</el-button>
      </div>
    </el-dialog>
    <get-code ref="getCode"></get-code>
    <get-url ref="getUrl" :url="connectUrl" :tempSystem="temp_system"></get-url>
    <rebateRatio ref="rebateRatio"></rebateRatio>
    <serviceRebateRatio ref="serviceRebateRatio"></serviceRebateRatio>
    <Consume ref="consume"></Consume>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from "moment";
import { myMixins } from "./mixin/index.js";
import {
  Ip_originList,
  Ip_updateLandingPage,
  Ip_addLandingPage,
} from "@/config/api/index";
import getCode from "./component/getcode";
import getUrl from "./component/geturl";
import rebateRatio from "./component/rebate_ratio";
import serviceRebateRatio from "./component/service_rebate_ratio";
import Consume from "./component/consume";
import store from "store2";
import FilterLayout from "@/layout/form";
import TableLayout from "@/layout/table";
import {
  otherPlatformList,
  otherPlatformListIOS,
  otherPlatformListApplet,
  getConnectUrl,
} from "./utils";
import router from "@/common/router/index";
import SelectChannel from "@/component/select-channel";
import SelectApp from '@/component/select-app';
export default {
  name: "ip_attribution_admin",
  mixins: [myMixins],
  components: {
    getCode,
    getUrl,
    FilterLayout,
    SelectChannel,
    TableLayout,
    rebateRatio,
    Consume,
    serviceRebateRatio
  },
  data() {
    return {
      moment: moment,
      orderType: "", // 表单的订单类型
      admin_id: "",
      changeSystemCreate: "",
      temp_system: "",
      xt_ios_android_lisiten_show: false,
      xt_send_time_show: false,
      ratio_show: true,
      is_lisiten: "2",
      lisitenApp: [],
      roleTree: {},
      options: [],
      showAdd: false,
      showchangeData: false,
      addSpecialShow: false,
      connectUrl: "",
      specialStep: false,
      fullscreenLoading: false,
      showchangeDataOne: false,
      fullscreenLoadingOne: false,
      cl_jl_flag: false,
      edit_jl_cl_flag: false,
      adminUserList: [],
      SadminUserList: [],
      akeyFlag: false,
      tokenlag: false,
      moneyArr: ["8", "9"], //显示消耗金额的投放方式
      scaleArr: ["1", "4", '73', '74', '75', "5", "2", "7", "12", "13", "16", "-1",'35', '25', '24', '26', '59', '40', '79', '41', '42', '58', '66', "69", "67", "68", "71", '70', '80', '81', '84'], //显示返点比例的投放方式
      urlArr: ["15", '39', '44', '35', '76', '60', '63', '64', '65', '79', '41', '42', "67", "68", "71"], //不显示获取URL的的投放方式
      overseasUrlArr: ['40', '41', '42', '61', '62', '63', '64', '65', '67', '68', '71', '76', '79'],
      trackerTokenArr: [40, 81], //显示获取trackerToken的的投放方式
      allMoneyArr: [11, 17, 20, 21, 57], //显示发布时间、总预算、单价的平台
      showChannelTypeArr: [8, 14, 11, 17, 57, 22, 77, 72, 56, 9, 20, 21, 23], //不显示渠道类型的投放方式
      planIdArr: [24, 25, 26, 40, 58, 79], //显示计划ID的投放方式
      overseasArr: [42, 41, 40, 35, 67, 68, 71, 79],//海外 服务比例展示
      conversion_target_flag: [1, 4, 73, 74, 75, 2, 5, 69, 84],
      addBtn: false, //禁用按钮
      appList: [], //app列表
      // pickerOptions: {}, //时间限制
      event_radio: "1", //
      eventIdList: [],
      versionFlag: false, // 新增投放是否显示【投放版本】
      nowApp_id: '',
      incorporationArr: [35, 13, 24, 25, 26, 40, 41, 42, 58, 67, 68, 71, 79],//走一体化投放的渠道
      rebateFlag: [58, 25, 13, 24, 26],
      source: "", // 来源
      token: ""  // v2的token
    };
  },
  created() {
    this.fetchList();
    this.originList();
    this.getRoleBtree();
    this.getApp();
    this.source = this.$route.query.source
  },
  mounted() {
    this.admin_id = JSON.parse(localStorage.getItem("user")).id;
    this.nowApp_id = router.history.current.query.appId;
    this.getAdmin();
    this.getAppList();
    this.getEventIdList();
    // this.getEventAction()
  },
  beforeCreate() {
    this.$options.components.SelectApp = require('@/component/select-app').default
    this.token = this.$route.query.token;
    if (this.token) {
      localStorage.setItem('loginToken', this.token);
    }
  },
  computed: {
    otherPlatformListHandle() {
      const { appId } = router.history.current.query;
      let arr = [];
      this.appList.forEach((item) => {
        if (item.id == appId) {
          if (item.system == "2") {
            arr = otherPlatformListIOS;
          } else if (item.system == "3" || item.system == "4") {
            arr = otherPlatformListApplet;
          }
          else {
            arr = otherPlatformList;
          }
        }
      });
      return arr;
    },
    otherPlatformHandle() {
      const { appId } = router.history.current.query;
      let arr = [];
      this.appList.forEach((item) => {
        if (item.id == appId) {
          arr = otherPlatformList;
        }
      });
      return arr;
    },
    FilterOps() {
      return [
        {
          label: "全部",
          value: "99",
        },
        ...this.otherPlatformListHandle,
      ]
    },
    conversion_target_list() {
      if (this.addForm.system_create == 1 || this.addForm.system_create == 5) {
        return this.juliangConversionList
      } else if (this.addForm.system_create == 4 || this.addForm.system_create == 73 || this.addForm.system_create == 74 || this.addForm.system_create == 75) {
        return this.baiduConversionList
      } else if (this.addForm.system_create == 2 || this.addForm.system_create == 69 || this.addForm.system_create == 84) {
        return this.tengxunConversionList
      } else {
        return []
      }
    }
  },
  watch: {
    "addForm.system_create"(newvalue) {
      const specialWay = [1, 2, 4, 73, 74, 75, 5, 8, 9, 16, 59, 66, 69, 70, 84];

      if (newvalue == 1) {
        this.addForm.domain = "";
      }

      this.addForm.origin = "";

      this.specialStep = !!specialWay.find((v) => v == newvalue);
      this.addSpecialShow = this.outPlatform(newvalue);
    },
  },
  filters: {
    formatnum(val) {
      let res = val.toString().replace(/\d+/, function (n) {
        // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
          return $1 + ",";
        });
      });
      return res;
    },
  },
  methods: {
    ...mapActions(['getApp']),
    // 获取app列表
    async getAppList() {
      const [err, res] = await this.$http.post("System/apps");
      if (err) return;
      this.appList = res;
    },
    formatPlatform(val) {
      if (!val) return "--";

      // 合并所有端口的投放方式进行回显
      const platform = [
        ...otherPlatformListIOS, ...otherPlatformListApplet, ...otherPlatformList
      ];
      const current = platform.find((v) => v.value == val);
      if (current) return current.label;
      return "--";
    },
    // 打开弹窗
    onShowAdd() {
      this.showAdd = true;
      this.versionFlag = false // 打开弹窗不展示投放版本 只有选择了巨量引擎才显示
      this.addForm = this.resetAddForm()
      this.$nextTick(() => {
        this.addSpecialShow = false;
        this.pickerOptions = Object.assign({}, this.pickerOptions, {
          disabledDate(time) {
            return time.getTime() < Date.now() - 2592000000;
          },
        });
      });
    },

    // 查看
    onLinkMore({ origin, system_create }) {
      this.$router.push({
        path:
          system_create == "3"
            ? "/count_center/ip_attribution/inside"
            : "/count_center/ip_attribution/statistics",
        query: {
          origin,
        },
      });
    },

    ratioBlur(e) {
      const val = e.target.value;
      var reg = /^\d+(?=\.{0,1}\d+$|$)/;
      if (!reg.test(val)) {
        this.addForm.ratio = "";
      }
    },

    lisitenAppidChange(e) {
      const idx = this.lisitenApp.findIndex((el) => el.id == e);
      if (idx > -1) {
        this.addForm.lisiten_app_system = this.lisitenApp[idx].system;
      }
    },

    // 投放方式改变
    otherPlatformListchange(e) {
      const systemCreateValue = this.addForm.system_create;
      this.addForm = {
        ...this.resetAddForm(),
        channel_type: '2',
        system_create: systemCreateValue
      }
      this.is_lisiten = "2";
      // 是否显示投放版本
      this.versionFlag = e == 1
      //下面几个id需要展示双端链接
      let xt_arr = [6, 8, 9, 14, 11, 17, 18, 19, 20, 21, 22, 77, 23, 55, 56, 57, 59, 80];
      // 这几个id不展示返点比例
      let not_ratio_arr = [
        55, 8, 14, 11, 9, 15, 39, 44, 17, 18, 19, 20, 21, 22, 77, 72, 23, 56, 76, 57, 60, 63, 64, 65, 6
      ];
      this.ratio_show = not_ratio_arr.indexOf(e) > -1 ? false : true;

      // 是否展示双端监测链接
      this.xt_ios_android_lisiten_show = xt_arr.indexOf(e) > -1 ? true : false;
      //巨量引擎 磁力引擎 腾讯广告
      const clJLvalidFlags = [1, 2, 5, 59, 4, 73, 74, 75, 66, 69, 70, 84];
      this.cl_jl_flag = clJLvalidFlags.includes(e);
      const appId = this.$route.query.appId;
      // 获取共用应用
      const { tree } = this.roleTree;
      let sharedApp = {};
      let appid_system = "";
      tree.forEach((department_el) => {
        department_el.node.forEach((group_el) => {
          group_el.node.forEach((project_el) => {
            project_el.node.forEach((app_el) => {
              if (app_el.id == appId) {
                sharedApp = project_el; // 获取当前app同一部门下的app
                appid_system = app_el.system; //查看当前app是什么端
              }
            });
          });
        });
      });
      let arr = [];
      sharedApp.node.forEach((el) => {
        if (el.system != appid_system) {
          arr.push(el);
        }
      });
      this.lisitenApp = arr;
      this.addForm.admin_id = this.admin_id;
    },
    // 获取app事业群分组
    async getRoleBtree() {
      const [err, res] = await this.$http.post("System/roleBtree", {
        loginId: store.get("user")["id"],
        loginToken: store.get("loginToken"),
      });
      if (err) return;
      this.roleTree = res;
    },
    // 获取负责人列表
    async getAdmin() {
      const [err, res] = await this.$http.post("Admin/getAdmin");
      if (err) return;
      this.adminUserList = res;
      this.SadminUserList = res;
    },
    // 获取代码
    getCode(data) {
      this.$refs.getCode.$data.dialogVisible = true;
      this.$refs.getCode.$data.data = data;
    },
    openRebate(origin) {
      this.$refs.rebateRatio.$data.info = origin;
      this.$refs.rebateRatio.getRebatesInfo();
    },
    openServiceRebateRatio(origin) {
      this.$refs.serviceRebateRatio.$data.info = origin;
      this.$refs.serviceRebateRatio.getRebatesInfo();
    },
    openConsume(origin) {
      this.$refs.consume.$data.info = origin;
      this.$refs.consume.getRebatesInfo();
    },
    // 获取URL
    getURL({
      system_create,
      origin,
      lisiten_appid,
      lisiten_app_system,
      appid,
      version,
      tracker_token
    }) {
      const { id, system } = this.$store.getters.getCurrentApp(
        this.$route.query.appId
      );
      let temp_system = system;
      this.temp_system = system
      if (lisiten_app_system && lisiten_appid) {
        if (lisiten_app_system == "1") {
          temp_system = "2";
        } else if (lisiten_app_system == "2") {
          temp_system = "1";
        }
      }
      const connectUrl = getConnectUrl({
        appid: appid,
        origin,
        system_create,
        system: temp_system,
        system2: lisiten_app_system,
        appid2: lisiten_appid,
        version,
        tracker_token: tracker_token ? tracker_token : ''
      });
      if (!connectUrl) {
        return this.$message.error("获取参数错误，请刷新后重试！");
      }

      this.connectUrl = connectUrl;
      if (this.urlArr.indexOf(system_create) !== -1) {
        this.connectUrl = "";
      }
      // 如果是外海w2b的投放方式且没有上传tracker_token，则不显示获取URL
      if (!tracker_token && this.trackerTokenArr.indexOf(Number(system_create)) !== -1) {
        this.connectUrl = "";
      }
      this.$refs.getUrl.$data.dialogVisible = true;
    },
    // 开始或停止
    ruing({ id, status }) {
      let operate = status == 0 ? "start" : "close";
      Ip_updateLandingPage({ id, operate }).then((res) => {
        if (res[2] == 1) {
          this.$message({
            message: res[3],
            type: "success",
          });
          this.landingPageList();
        }
      });
    },
    // 删除
    onRemove(id) {
      let operate = "delete";
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        Ip_updateLandingPage({ id, operate }).then((res) => {
          if (res[2] == 1) {
            this.$message({
              message: res[3],
              type: "success",
            });
            this.landingPageList();
          }
        });
      });
    },
    onBlur(e) {
      if (this.addForm.system_create == 76) {
        this.addForm.origin = e.target.value.toLowerCase();
        return
      }
      this.addForm.origin = e.target.value.toUpperCase();
    },
    originInputChange() {
      this.addForm.origin = this.addForm.origin.replace(
        /[ ]|[\u4E00-\u9FA5]/g,
        ""
      );
    },

    // 直接新增投放方式
    async onAdd() {
      this.addBtn = true;
      let { title, origin, system_create, lisiten_appid, ratio, date, invest_target } = this.addForm;
      if (
        !title ||
        !invest_target ||
        !origin ||
        !system_create ||
        (this.is_lisiten == "1" && !lisiten_appid) ||
        (ratio && !date) ||
        (!ratio && date)
      ) {
        this.$message({
          message: "请填写完整信息",
          type: "warning",
        });
        this.addBtn = false
        return;
      }
      // 投放方式为Google ads时子账户ID不能有特殊字符
      if (this.addForm.account_id && this.addForm.system_create == 42) {
        const regex = /^[a-zA-Z0-9]*$/; // 正则表达式，只允许字母和数字
        if (!regex.test(this.addForm.account_id)) {
          this.$message({
            message: "请填写正确的子账户id",
            type: "warning",
          });
          this.addBtn = false
          return;
        }
      }
      let errorMessage = "";
      this.$refs.addForm.validateField(["origin"], (errorMessage) => {
        if (err) {
          errorMessage = errorMessage;
        }
      });
      if (errorMessage) {
        this.addBtn = false
        return;
      }
      this.addForm.origin = this.ToCDB(this.addForm.origin);
      // 包括字节巨量引擎 百度-SEM 快手-磁力引擎 抖音星图-传播任务（KOL）
      if (this.incorporationArr.indexOf(this.addForm.system_create) !== -1) {
        const [err, res] = await this.$http.post("Ip/saveLanding", {
          ...this.addForm,
          origin: this.addForm.origin.toUpperCase(),
          account_name: '无',
          proceeds_user: "无",
        });
        if (err) {
          this.addBtn = false;
          return
        }
        this.$message({
          message: '新增成功',
          type: "success",
        });
        this.showAdd = false;
        this.addBtn = false;
        this.searchForm.search = "";
        this.searchForm.channel = [];
        this.searchForm.admin_id = [];
        this.originList();
        this.tableOpt.currentPage = 1;
        this.fetchList();
      } else if ([1, 4, 73, 74, 75, 5, 8, 59, 66, 84].indexOf(this.addForm.system_create) !== -1) {
        Ip_addLandingPage({
          ...this.addForm,
          origin: this.addForm.origin.toUpperCase(),
        }).then((res) => {
          if (res.length === 1) {
            this.$message.error(res[0]);
            this.addBtn = false;
          } else if (res[2] === 1) {
            this.$message({
              message: res[3],
              type: "success",
            });
            this.showAdd = false;
            this.addBtn = false;
            this.searchForm.search = "";
            this.searchForm.channel = [];
            this.searchForm.admin_id = [];
            this.originList();
            this.tableOpt.currentPage = 1;
            this.fetchList();
          }
        });
      } else if (
        // 不包括字节巨量引擎 百度-SEM 快手-磁力引擎 抖音星图-传播任务（KOL）以及不包括落地页和小红书落地页
        [1, 66, 4, 73, 74, 75, 5, 84, 8, 59].indexOf(this.addForm.system_create) === -1 &&
        this.addForm.system_create != 55 &&
        this.addForm.system_create != 18
      ) {
        let [res, err] = await this.$http.post("Ip/addLandingInvestChannel", {
          loginId: store.get("user")["id"],
          loginToken: store.get("loginToken"),
          ...this.addForm,
          origin: this.addForm.origin.toUpperCase(),
        });

        if (err) {
          this.addBtn = false;
          return;
        }
        this.showAdd = false;
        this.addBtn = false;
        this.searchForm.search = "";
        this.searchForm.channel = [];
        this.searchForm.admin_id = [];
        this.originList();
        this.tableOpt.currentPage = 1;
        this.fetchList();
      } else if (this.addForm.system_create == 18 || this.addForm.system_create == 55) {
        // 只有小红书落地页执行
        let [res, err] = await this.$http.post("Ip/addLandingInvestChannel", {
          ...this.addForm,
          origin: this.addForm.origin.toUpperCase(),
        });

        if (err) {
          this.addBtn = false;
          return;
        }
        this.showAdd = false;
        this.addBtn = false;
        this.searchForm.search = "";
        this.searchForm.channel = [];
        this.searchForm.admin_id = [];
        this.originList();
        this.tableOpt.currentPage = 1;
        this.fetchList();
      }
    },
    // 获取来源
    originList() {
      Ip_originList({ type: 99 }).then((res) => {
        this.options = res[1].map((item) => {
          return {
            label: item,
            value: item,
          };
        });
        this.options.unshift({
          label: "全部",
          value: "",
        });
      });
    },
    onSubmit() {
      this.tableOpt.currentPage = 1;
      this.fetchList();
    },
    onPageChange(current) {
      this.tableOpt.currentPage = current;
      this.fetchList();
    },
    onSizeChange(current) {
      this.tableOpt.pageSize = current;
      this.fetchList();
    },
    async fetchList() {
      const { searchForm, tableOpt, sort } = this;

      this.tableData.loading = true;

      const [err, res] = await this.$http.post("Ip/landingPageList", {
        ...searchForm,
        ...tableOpt,
        ...sort,
        channel: this.searchForm.channel.join(","),
      });

      this.tableData.loading = false;

      if (err) return;

      const { list, currentPage, total } = res;

      this.tableData.data = list;
      this.tableData.currentPage = currentPage;
      this.tableData.total = total;
    },

    // 新增渠道需要点击下一步
    onNextSpecial() {
      let {
        title,
        origin,
        system_create,
        lisiten_appid,
        ratio,
        channel_type,
        date,
        lisiten_app_system,
        send_time,
        event_id,
        event_name,
        event_type,
        note,
        admin_id,
        version,
        invest_target,
        conversion_target
      } = this.addForm;
      if (
        !title ||
        !invest_target ||
        !origin ||
        !system_create ||
        (this.is_lisiten == 1 && !lisiten_appid) ||
        (ratio && !date) ||
        (!ratio && date) ||
        (system_create == 1 && version == '')  // 选了巨量引擎必须填写版本号
      ) {
        this.$message({
          message: "请填写完整信息",
          type: "warning",
        });

        return;
      }
      if ((!event_name && !event_id) || (event_name && event_id)) {
      } else {
        this.$refs.addForm.validate((v, i) => { });
        this.$message({
          message: "请填写完整信息",
          type: "warning",
        });
        return;
      }
      let errorMessage = "";
      this.$refs.addForm.validateField(["origin"], (errorMessage) => {
        if (err) {
          errorMessage = errorMessage;
        }
      });
      if (errorMessage) {
        return;
      }

      origin = this.ToCDB(origin);

      let appName = this.$store.getters.getCurrentApp(
        this.$route.query.appId
      ).title;

      // 抖音星图-传播任务（KOL）
      if (system_create === 8) {
        this.$router.push({
          path: "/count_center/ip_attribution/web_admin/add_xingtu",
          query: {
            title,
            origin,
            system_create,
            lisiten_appid,
            lisiten_app_system,
            send_time,
            appName,
            note,
            admin_id,
            invest_target,
            channel_type,
            source: this.source
          },
        });
        return;
      }

      // 百度-SEM
      if (system_create === 4 || system_create === 73 || system_create === 74 || system_create === 75) {
        this.$router.push({
          path: "/count_center/ip_attribution/web_admin/add_baidu",
          query: {
            title,
            origin,
            system_create,
            appName,
            ratio,
            date,
            note,
            admin_id,
            invest_target,
            channel_type,
            event_id,
            event_name,
            event_type,
            conversion_target,
            source: this.source
          },
        });
        return;
      }

      // 腾讯广告
      if (system_create == 2) {
        this.$router.push({
          path: "/count_center/ip_attribution/web_admin/add_tengxun",
          query: {
            title,
            origin,
            system_create,
            appName,
            ratio,
            date,
            note,
            admin_id,
            invest_target,
            channel_type,
            event_id,
            event_name,
            event_type,
            conversion_target,
            source: this.source
          },
        });
        return;
      }
      if (system_create == 70 || system_create == 69) {
        this.$router.push({
          path: "/count_center/ip_attribution/web_admin/add_tengxun",
          query: {
            title,
            origin,
            system_create,
            appName,
            ratio,
            date,
            note,
            admin_id,
            invest_target,
            channel_type,
            event_id,
            event_name,
            event_type,
            source: this.source
          },
        });
        return;
      }

      // "快手聚星-传播任务（KOL）
      if (system_create == 9) {
        this.$router.push({
          path: "/count_center/ip_attribution/web_admin/add_kuaishou",
          query: {
            title,
            origin,
            system_create,
            appName,
            lisiten_appid,
            lisiten_app_system,
            send_time,
            note,
            admin_id,
            invest_target,
            channel_type,
            source: this.source
          },
        });
        return;
      }
      // 其他方式走默认
      this.$router.push({
        path: "/count_center/ip_attribution/web_admin/add_special",
        query: {
          title,
          origin,
          system_create,
          lisiten_appid,
          lisiten_app_system,
          appName,
          date,
          ratio,
          event_id,
          event_name,
          event_type,
          note,
          admin_id,
          version,
          invest_target,
          channel_type,
          conversion_target,
          source: this.source
        },
      });
    },
    outPlatform(val) {
      const list = this.otherPlatformListHandle.find((v) => v.value == val);
      return list;
    },
    // 修改当前星图用户名与ID
    async changeData(val) {
      this.changeSystemCreate = val.system_create;
      this.fullscreenLoading = true;
      const [err, res] = await this.$http.post("Ip/queryAdvertiser", {
        appId: val.appid,
        channel: val.origin,
        platform: val.system_create,
      });
      if (err) {
        return;
      }
      this.getAdmin();
      this.fullscreenLoading = false;
      if (res && res.id) {
        this.$nextTick(() => {
          this.changeForm.proceeds_user = res.proceeds_user;
          this.changeForm.ad_id = res.ad_id;
          this.changeForm.ad_name = res.ad_name;
          this.changeForm.id = res.id;
          this.changeForm.appId = val.appid;
          this.changeForm.admin_id = res.admin_id;
          this.changeForm.channel = res.channel;
          this.changeForm.platform = res.platform;
          this.changeForm.admin_date = res.admin_date || "";
          this.changeForm.channel_type = res.channel_type;
          // this.changeForm.settlement_date = res.settlement_date!='0'&&res.settlement_date?res.settlement_date:"";
          this.changeForm.note = res.note || "";
          this.changeForm.note_date = res.note_date || "";
        });
        this.showchangeData = true;
      } else {
        this.$message.error("未查询到相应的配置信息！");
      }
    },
    async changeDataOne(val) {
      this.fullscreenLoadingOne = true;
      this.tableData.loading = true;
      const [err, res] = await this.$http.post("Ip/queryAdvertiser", {
        appId: val.appid,
        channel: val.origin,
        platform: val.system_create,
      });
      this.akeyFlag = val.system_create === "16" ? true : false;
      this.tokenlag = val.system_create === "16" ? true : false;
      // 巨量引擎 磁力引擎 腾讯广告  网易
      const validSystemCreateValues = [1, 2, 4, 73, 74, 75, 5, 84, 59, 66, 70];
      this.edit_jl_cl_flag = validSystemCreateValues.includes(val.system_create);
      if (err) {
        return;
      }
      this.getAdmin();
      this.tableData.loading = false;
      this.fullscreenLoadingOne = false;
      this.showchangeDataOne = true;
      this.$nextTick(() => {
        this.changeFormOne.admin_id = res.admin_id == 55 ? "" : res.admin_id;
        this.changeFormOne.channel = val.origin;
        this.changeFormOne.platform = res.platform;
        this.changeFormOne.akey = res.akey;
        this.changeFormOne.id = res.id;
        this.changeFormOne.access_token = res.access_token;
        this.changeFormOne.admin_date = res.admin_date || "";
        this.changeFormOne.event_id = res.event_id || "";
        this.changeFormOne.event_name = res.event_name || "";
        this.changeFormOne.note = res.note || "";
        // this.changeFormOne.note_date = res.note_date || "";
        this.$set(this.changeFormOne, 'note_date', res.note_date || "")
        this.changeFormOne.channel_type = res.channel_type;
        this.changeFormOne.settlement_date =
          res.settlement_date != "0" && res.settlement_date
            ? res.settlement_date
            : "";
      });
    },
    onChangeData() {
      this.$refs.changeForm.validate(async (v, i) => {
        if (v) {
          const [err, res] = await this.$http.post("Ip/editAdvertiser", {
            ...this.changeForm,
          });
          if (err) {
            return;
          }
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.showchangeData = false;
          this.changeForm = resetChangeForm();
          this.fetchList();
        } else {
          return;
        }
      });
    },
    async onChangeDataOne() {
      this.$refs.changeFormOne.validate(async (v, i) => {
        if (v) {
          const [err, res] = await this.$http.post("Ip/editAdvertiser", {
            ...this.changeFormOne,
          });
          if (err) {
            return;
          }
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.dataOneDown(); // 初始化弹窗的数据
          this.fetchList();
        } else {
          return;
        }
      });
    },

    dataOneDown() {
      this.showchangeDataOne = false;
      this.akeyFlag = false;
      this.tokenlag = false;
      this.changeFormOne = this.resetChangeFormOne()
    },

    onSortChange(data) {
      const { prop, order } = data;
      this.sort = { prop, order };
      this.tableOpt.currentPage = 1;
      this.fetchList();
    },

    testareaChange(e) {
      this.$forceUpdate(e);
      if (!e) {
        this.changeForm.note_date = "";
        this.changeFormOne.note_date = "";
      }
    },

    ToCDB(str) {
      let tmp = "";
      for (let i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) == 12288) {
          tmp += String.fromCharCode(str.charCodeAt(i) - 12256);
          continue;
        }
        if (str.charCodeAt(i) > 65280 && str.charCodeAt(i) < 65375) {
          tmp += String.fromCharCode(str.charCodeAt(i) - 65248);
        } else {
          tmp += String.fromCharCode(str.charCodeAt(i));
        }
      }
      return tmp;
    },
    // 单选取消
    getCurrentRow(id) {
      //this.questionnaireId 为上一次存储的id与这一次比对判断是否和上次点击的一致
      if (this.addForm.event_type == id && this.addForm.event_type) {
        this.addForm.event_type = "";
      } else {
        this.addForm.event_type = id;
      }
      this.addForm.event_id = "";
      this.addForm.event_name = "";
    },

    // 获取行为列表
    async getEventIdList() {
      const [err, res] = await this.$http.post("key_action/list", {
        appid: router.history.current.query.appId,
        status: 1,
        pageSize: 1000,
        action_name: "",
        action_id: "",
      });
      if (err || !res.list) {
        return;
      }
      // if (!res.list) {
      //   return;
      // }
      let total_page =
        res.total_page || res.last_page || res.pageSize
          ? res.total / res.pageSize
          : 0;
      const arr = res.data ? [...res.data] : [...res.list];

      if (total_page > 0) {
        for (let index = 1; index < total_page; index++) {
          const [err, res] = await this.$http.post("key_action/list", {
            appid: router.history.current.query.appId,
            status: 1,
            pageSize: 1000,
            action_name: "",
            action_id: "",
          });
          if (res.data) {
            arr.push(...res.data);
          } else {
            arr.push(...res.list);
          }
        }
      }
      this.eventIdList = arr;
    },
    // 改变事件名称
    changeEventName(data) {
      this.addForm.event_id = data;
      this.eventIdList.forEach((item) => {
        if (item.action_id == data) {
          this.addForm.event_name = item.action_name;
        }
      });
    },

    changepromotino_money(val, prop) {
      this.addForm[prop] = this.proving(val);
    },

    proving(e) {
      let num = e;
      // 先把非数字的都替换掉，除了数字和.
      num = num.replace(/[^\d.]/g, "");
      // 必须保证第一个为数字而不是.
      num = num.replace(/^\./g, "");
      // 保证只有出现一个.而没有多个.
      num = num.replace(/\.{3,}/g, "");
      // 保证.只出现一次，而不能出现两次以上
      num = num.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      let index = -1;
      for (let i in num) {
        if (num[i] === ".") {
          index = i;
        }
        if (index !== -1) {
          if (i - index > 2) {
            num = num.substring(0, num.length - 1);
          }
        }
      }
      return num;
    },
    // 清除所有空格
    eventBlur(e) {
      if (this.addForm.event_id) {
        this.addForm.event_id = this.addForm.event_id.replace(/\s+/g, "");
      }
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/style/v2.scss";

.filter {
  background-color: #fff;
  padding: 20px;
  margin-bottom: 20px;

  .label {
    margin-right: 12px;
    font-size: 14px;
  }
}

.table {
  padding: 20px;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  .downDataToExcel {
    margin-bottom: 20px;
  }

  .pagination {
    margin: 20px;
  }
}

.el-range-editor,
.el-select {
  margin-right: 20px;
}

.event_box {

  // display: flex;
  // justify-content: space-around;
  .el-select {
    margin: 10px 0;
  }
}

.fontW16 {
  font-size: 12px;
  font-weight: 600;
}

.fl_right {
  display: flex;
  justify-content: space-between;
}
</style>